import doc                         from 'decorators/doc';
import model                       from 'decorators/model';
import { urn }                     from 'helpers/ModelDictionary';
import InterventionPrivateApiModel from '../../abstracts/InterventionPrivateApiModel';

@doc.path('/sectors/{?id}')
@model.staticLabel('Secteur')
@urn('$', 'intervention', 'sector')
export default class SectorModel extends InterventionPrivateApiModel {
	public _filters: ModelFiltersExtended<{
		'archived': '0' | '1';
	}> = {};

	public _sorts: ModelSortsExtended<{
		'id': string;
		'label': string;
		'position': string;
	}> = {};

	@doc.string declare label: string;
	@doc.string declare position: number;
}